import React, { useState } from 'react';
import './Tooltip.css'; 

const Tooltip = ({ text, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className="tooltip-container"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && <div className="tooltip-text">
        <p className='text-tooltip'>{text}</p>
        </div>}
    </div>
  );
}


export default Tooltip;